import * as types from './constants';
import { sortDataByOrder } from '@/helpers/functions'

const setQuestions = ({ commit }, data) => {
  return commit(types.SET_QUESTIONS, data);
}

const setQuestion = ({ commit }, data) => {
  return commit(types.SET_QUESTION, data);
}

const validateQuestion = ({ commit }, data) => {
  return commit(types.VALIDATE_QUESTION, data);
}

const setQuestionScroll = ({ commit }, data) => {
  return commit(types.SET_QUESTION_SCROLL, data);
}

const sortDataQuestions = ({ commit }, data) => {
  let dataEdit = sortDataByOrder(data)
  return commit(types.SET_QUESTIONS, dataEdit);
}

const setApprovalItem = ({ commit }, data) => {
  commit(types.SET_VIEW_APPROVAL_ITEM, data)
};

const setQuestionGroupInfo = ({ commit }, data) => {
  return commit(types.SET_QUESTION_GROUP, data)
}

const setCorrectQuestionGroup = ({ commit }, data) => {
  return commit(types.SET_CORRECT_GROUP_VALUE, data)
}

const setVituralKeyVal = ({ commit }, data) => {
  return commit(types.SET_VITURAL_KEYBOARD_VALUE, data)
}

const setQuestionData4CheckAnswer = ({ commit }, data) => {
  return commit(types.SET_QUESTION_DATA_4_CHECK_ANSWER, data)
}

const setQuestionList4CheckAnswer = ({ commit }, data) => {
  return commit(types.SET_QUESTION_LIST_4_CHECK_ANSWER, data)
}

const acSetTxtInputSelected = ({ commit }, data) => {
  return commit(types.SET_TXT_SELECTED_INPUT, data)
}

export default {
  setQuestions,
  setQuestion,
  validateQuestion,
  setQuestionScroll,
  sortDataQuestions,
  setApprovalItem,
  setQuestionGroupInfo,
  setCorrectQuestionGroup,
  setVituralKeyVal,
  setQuestionData4CheckAnswer,
  setQuestionList4CheckAnswer,
  acSetTxtInputSelected
}